<template>
  <v-theme-provider :dark="dark">
    <div>
      <base-info-card
        :title="title"
        color="primary"
      >
        <slot />
      </base-info-card>

      <template v-for="({ icon, text, title: t}, i) in business">
        <base-avatar-card
          :key="i"
          :icon="icon"
          :outlined="false"
          :title="!dense ? t : undefined"
          color="transparent"
          horizontal
          space="0"
        >
          <!-- Do not use v-html for user -->
          <!-- provided values -->
          <div v-html="text" />
        </base-avatar-card>

        <v-divider
          v-if="i + 1 !== business.length"
          :key="`divider-${i}`"
          class="my-2"
        />
      </template>
    </div>
  </v-theme-provider>
</template>

<script>
  export default {
    name: 'BaseBusinessContact',

    props: {
      dark: Boolean,
      dense: Boolean,
      title: String,
    },

    data: () => ({
      business: [
        {
          icon: 'mdi-map-marker-outline',
          title: 'Addresse',
          text: 'IFEA Treuhand GmbH<br>Bernrainstrasse 1<br>CH-8280 Kreuzlingen<br>UID: CHE-323.111.965<br>Telefon: <a href="tel:+41716668000" target="_blank" style="color: inherit">+41 71 666 8000</a><br>E-Mail: <a href="mailto:info@ifea-treuhand.ch" target="_blank" style="color: inherit">info@ifea-treuhand.ch</a>',
        },
        {
          icon: 'mdi-account-tie-woman',
          title: 'Verwantwortliche Personen',
          text: '<b>Verwantwortliche Personen:</b><br>Linda Castioni, Geschäftsführerin & Inhaberin, <a href="mailto:linda.castioni@ifea-treuhand.ch" target="_blank" style="color: inherit">linda.castioni@ifea-treuhand.ch</a>',
        },
        {
          icon: 'mdi-security',
          title: 'Haftungsausschluss',
          text: '<b>Haftungsausschluss</b><br>IFEA bemüht sich um die Richtigkeit und Vollständigkeit der auf dieser Website zur Verfügung gestellten Informationen. Die auf der Website von IFEA enthaltenen Angaben werden lediglich zu Informationszwecken zur Verfügung gestellt. Der Autor übernimmt keinerlei Gewähr hinsichtlich der inhaltlichen Richtigkeit, Genauigkeit, Aktualität, Zuverlässigkeit und Vollständigkeit der Informationen.<br>Haftungsansprüche gegen den Autor wegen Schäden materieller oder immaterieller Art, welche aus dem Zugriff oder der Nutzung bzw. Nichtnutzung der veröffentlichten Informationen, durch Missbrauch der Verbindung oder durch technische Störungen entstanden sind, werden ausgeschlossen.<br>Alle Angebote sind unverbindlich. Der Autor behält es sich ausdrücklich vor, Teile der Seiten oder das gesamte Angebot ohne besondere Ankündigung zu verändern, zu ergänzen, zu löschen oder die Veröffentlichung zeitweise oder endgültig einzustellen.',
        },
        {
          icon: 'mdi-shield-link-variant-outline',
          title: 'Haftungsausschluss für Links',
          text: '<b>Haftungsausschluss für Links</b><br>Verweise und Links auf Webseiten Dritter liegen ausserhalb unseres Verantwortungsbereichs. Es wird jegliche Verantwortung für solche Webseiten abgelehnt. Der Zugriff und die Nutzung solcher Webseiten erfolgen auf eigene Gefahr des jeweiligen Nutzers.',
        },
        {
          icon: 'mdi-copyright',
          title: 'Urheberrechte',
          text: '<b>Urheberrechte</b><br>Die Urheber- und alle anderen Rechte an Inhalten, Bildern, Fotos oder anderen Dateien auf dieser Website, gehören ausschliesslich der IFEA Treuhand GmbH oder den speziell genannten Rechteinhabern. Für die Reproduktion jeglicher Elemente ist die schriftliche Zustimmung des Urheberrechtsträgers im Voraus einzuholen.',
        },
      ],
    }),
  }
</script>
